// The only place money, points and rates are turned into text. Inputs are integers from the API
// (cents, points) or decimal strings (rates); no float math touches money.

const intFmt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

function groupDigits(n: bigint): string {
  return intFmt.format(n)
}

/** Integer cents → "$1,234.56" (negative → "-$1,234.56"). */
export function cents(n: number): string {
  if (!Number.isInteger(n)) throw new Error(`cents() needs an integer, got ${n}`)
  const neg = n < 0
  const abs = BigInt(Math.abs(n))
  const dollars = abs / 100n
  const rest = (abs % 100n).toString().padStart(2, '0')
  return `${neg ? '-' : ''}$${groupDigits(dollars)}.${rest}`
}

/** Integer points → "1,500". */
export function points(n: number): string {
  if (!Number.isInteger(n)) throw new Error(`points() needs an integer, got ${n}`)
  return n < 0 ? `-${groupDigits(BigInt(-n))}` : groupDigits(BigInt(n))
}

/** Decimal rate string ("0.5000") → "0.5 points per $1" (CHANGE-007: everyday words, no "pt/$"). */
export function rate(r: string | number | null | undefined): string {
  if (r === null || r === undefined || r === '') return '—'
  let s = String(r)
  if (s.includes('.')) s = s.replace(/0+$/, '').replace(/\.$/, '')
  return `${s} ${s === '1' ? 'point' : 'points'} per $1`
}

/** ISO date or datetime → "Sep 15, 2026" (UTC). */
export function day(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
}

/** "YYYY-MM-01" → "Sep 2026" (UTC). */
export function month(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`)
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' })
}
